import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';

export const userColumns = [
 
  {
    field: "emrNumber",
    headerName: "Emr Number",
    width: 200,
  },
  {
    field: "departmentName",
    headerName: "Department Name",
    width: 150,
  },
  {
    field: "departmentCode",
    headerName: "Department Code",
    width: 150,
  },
  {
    field: "doctorName",
    headerName: "Doctor Name",
    width: 200,
  },
  {
    field: "patientName",
    headerName: "Patient Name",
    width: 150,
  },
  {
    field: "referralCode",
    headerName: "Referral Code",
    width: 110,
  },
  

  {
    field: "age",
    headerName: "Age",
    width: 80,
  },
  {
    field: "gender",
    headerName: "Gender",
    width: 80,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {
            params?.row?.gender === "0" ? <><WomanIcon style={{ color: "pink"}}/>Female </>: 
            params?.row?.gender === "1" ? <><ManIcon style={{ color: "blue"}} /> Male</> : "Others"
          }
          
        </div>
      );
    },
  },
  {
    field: "mobile",
    headerName: "Mobile",
    width: 100,
  },
  {
    field: "address",
    headerName: "Address",
    width: 100,
  },
];
